import { Form, InputGroup } from 'react-bootstrap'
import { Eye, EyeOff } from 'lucide-react'

export default function Password(props) {

    const { label_name, placeholder, disabled, name, value, onChange, onBlur, error, mandatory, reference, tabIndex, showPassword, setShowPassword } = props

    return (
        <>
            <Form.Group className="mb-2 password-field" controlId={name}>
                <Form.Label className='form_label'>{label_name}{mandatory ? <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>
                <InputGroup className="password-input-group">
                    <Form.Control
                        ref={reference}
                        type={showPassword ? 'text' : 'password'}
                        size="sm"
                        placeholder={placeholder}
                        disabled={disabled}
                        className='form_input'
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                    <InputGroup.Text
                        className="password-eye-btn"
                        onClick={() => setShowPassword(!showPassword)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault()
                                setShowPassword(!showPassword)
                            }
                        }}
                    >
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </InputGroup.Text>
                </InputGroup>
                {error}
            </Form.Group>
        </>
    )
}
